// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HSq4EqLSgpcAM_xVuay1{display:flex;gap:10px;width:80vw;min-height:200px;max-height:550px;height:80vh;min-width:300px;max-width:1000px;white-space:pre-wrap}.HSq4EqLSgpcAM_xVuay1 .t83TRyjtTODYWLE8bx_S{font-size:10px;color:#8496b9}.HSq4EqLSgpcAM_xVuay1 .tMAPulmoyREeoCP7aXcg{display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;padding:1rem;font-size:12px !important}.HSq4EqLSgpcAM_xVuay1 .tMAPulmoyREeoCP7aXcg .hnwMwTn4CA3M1fohmxx7{width:100%;max-width:800px;margin:0 auto;display:block}.HSq4EqLSgpcAM_xVuay1 .tMAPulmoyREeoCP7aXcg .t83TRyjtTODYWLE8bx_S{text-align:center;margin-top:1rem;font-style:italic}.HSq4EqLSgpcAM_xVuay1 .tMAPulmoyREeoCP7aXcg .fJOK8sHsz0W07SixDVpc{margin-bottom:1.5rem;line-height:1.6}.HSq4EqLSgpcAM_xVuay1 .tMAPulmoyREeoCP7aXcg .SvC6UIwN82iocoBsujHS{list-style-type:disc;padding-left:2rem;margin:0}.HSq4EqLSgpcAM_xVuay1 .tMAPulmoyREeoCP7aXcg .SvC6UIwN82iocoBsujHS li{margin-bottom:.75rem;line-height:1.4}.HSq4EqLSgpcAM_xVuay1 .tMAPulmoyREeoCP7aXcg .h1NmiGLoVki7uOzdIxjJ{line-height:1.6;white-space:pre-wrap}.HSq4EqLSgpcAM_xVuay1 .oj9CLVYZA3QCKVxRyAJ6{width:40%;font-size:12px;margin-bottom:2rem}.HSq4EqLSgpcAM_xVuay1 .WuBhUicyY4ScHevJRj4Z{font-size:1.5rem;font-weight:bold;margin-top:0;margin-bottom:1rem;color:#6e32f0}.HSq4EqLSgpcAM_xVuay1 .Vh26ZYpdmfjSS5LjFXjd{font-size:1rem;line-height:1.5}.HSq4EqLSgpcAM_xVuay1 .wtSFR0CtdxRm7f3Ue350{height:100%;background-color:#e5e5e5;margin:2rem 0;width:2px}.HSq4EqLSgpcAM_xVuay1 p{font-size:12px !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"slide": `HSq4EqLSgpcAM_xVuay1`,
	"imgDescription": `t83TRyjtTODYWLE8bx_S`,
	"carouselItem": `tMAPulmoyREeoCP7aXcg`,
	"speakersSetup": `hnwMwTn4CA3M1fohmxx7`,
	"topText": `fJOK8sHsz0W07SixDVpc`,
	"bulletPoints": `SvC6UIwN82iocoBsujHS`,
	"bottomText": `h1NmiGLoVki7uOzdIxjJ`,
	"content": `oj9CLVYZA3QCKVxRyAJ6`,
	"title": `WuBhUicyY4ScHevJRj4Z`,
	"description": `Vh26ZYpdmfjSS5LjFXjd`,
	"divider": `wtSFR0CtdxRm7f3Ue350`
};
export default ___CSS_LOADER_EXPORT___;
